export function onlyNumbersValidator(event: KeyboardEvent) {
  const keyCode = event.keyCode || event.which
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 48) {
    event.preventDefault()
  }
}
